<div *ngIf="loading.loadingDelete">
  <ngx-skeleton-loader [theme]="{'height': '347px', 'margin-bottom': 0, 'margin-top': '5px'}"></ngx-skeleton-loader>
</div>
<div *ngIf="!loading.loadingDelete" class="single-equipment-table">
  <table>
    <tbody>
      <tr>
        <td translate>equipment.details.nav-tabs.overview.table.mac-address</td>
        <td>{{equipment.mac_address}}</td>
        <td style="width: 240px; text-align: right;">
          <button class="vox-btn btn btn-danger" [disabled]="company && company.readOnly" (click)="deleteEquipment()">
            <i class="icon-small-delete"></i>
            <span translate>equipment.details.buttons.delete-equipment</span>
          </button>
        </td>
      </tr>
      <tr>
        <td translate>equipment.details.nav-tabs.overview.table.model</td>
        <td>{{equipment.model}}</td>
        <td></td>
      </tr>
      <tr>
        <td translate>equipment.details.nav-tabs.overview.table.status</td>
        <td>
          <gdp-equipment-status [status]="equipment.status"></gdp-equipment-status>
        </td>
        <td></td>
      </tr>
      <tr *ngIf="loading.loadingReset">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '40px', 'margin-bottom': 0, 'margin-top': '5px'}">
          </ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loading.loadingReset">
        <td translate>equipment.details.nav-tabs.overview.table.provisioning-done</td>
        <td>{{equipment.provisioning_done}}</td>

        <td>
          <button class="vox-btn btn btn-danger" [disabled]="company && company.readOnly" (click)="resetProvisioning()">
            {{'common.reset' | translate}}
          </button>
        </td>
      </tr>
      <tr>
        <td translate>equipment.details.nav-tabs.overview.table.firmware-update</td>
        <td></td>
        <td class="text-right">
          <vox-toggle placement="left" [disableTooltip]="!company || !company.readOnly" [ngbTooltip]="'company.overview.disabled-tooltip' | translate" [loading]="loading.loadingFwUPdateflag" [toggleOn]="equipment.fw_update" [config]="{isAquamarine: true, disabled: company && company.readOnly}"
          (toggleOnChange)="updateFwUpdateFlag()">
        </vox-toggle>
        </td>
      </tr>
      <tr *ngIf="loading.loadingRegistered || loading.loadingReboot">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '40px', 'margin-bottom': 0, 'margin-top': '5px'}">
          </ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loading.loadingRegistered && !loading.loadingReboot">
        <td translate>equipment.details.nav-tabs.overview.table.is-registered</td>
        <td>{{isEquipmentRegistered}}</td>
        <td class="two-button-tooltip">
          <button class="vox-btn btn btn-success mb-1" [disabled]="company && company.readOnly"
            (click)="getRegisteredStatus()">
            {{'equipment.details.buttons.refresh' | translate}}
          </button>
          <!-- ngbTooltip doesn't work on disabled elements so
          a container to catch the hover is necessary -->
          <div class="tooltip-container" [ngbTooltip]="getRebootTooltip() | translate">
            <button class="vox-btn btn btn-danger" [disabled]="company && company.readOnly || !isEquipmentRegistered"
              (click)="rebootEquipment()">
              {{'equipment.details.buttons.reboot' | translate}}
            </button>
          </div>
        </td>
      </tr>
      <tr>
        <td>Blacklisted:</td>
        <td></td>
        <td class="text-right">
          <div class="tooltip-container" [disableTooltip]="company && company.readOnly" placement="left" [ngbTooltip]="'equipment.details.buttons.blacklist-tooltip' | translate">
          <vox-toggle placement="left" [disableTooltip]="!company || !company.readOnly" [ngbTooltip]="'company.overview.disabled-tooltip' | translate" [loading]="loading.loadingBlacklist" [toggleOn]="equipment.blacklisted" [config]="{isAquamarine: true, disabled: company && company.readOnly}"
          (toggleOnChange)="toggleBlacklist()">
        </vox-toggle>
          </div>
        </td>
      </tr>
      <tr>
        <td>BLF:</td>
        <td></td>
        <td class="text-right">
          <vox-toggle placement="left" [disableTooltip]="!company || !company.readOnly" [ngbTooltip]="'company.overview.disabled-tooltip' | translate" [loading]="loading.loadingBlf" [toggleOn]="equipment.blf" [config]="{isAquamarine: true, disabled: company && company.readOnly}"
          (toggleOnChange)="toggleBlf()">
        </vox-toggle>
        </td>
      </tr>
      <tr *ngIf="loading.loadingAllocate">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '40px', 'margin-bottom': 0, 'margin-top': '5px'}">
          </ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loading.loadingAllocate">
        <td translate>equipment.details.nav-tabs.overview.table.allocated-pbx</td>
        <ng-container *ngIf="equipment.pbx">
          <td class="properties-list">
            <span class="property-obj">
              <b translate>equipment.details.table.alphaname</b>
              <span class="property-value">{{equipment.pbx.alphaname}}</span>
            </span>
            <span class="property-obj">
              <b translate>equipment.details.table.company-id</b>
              <span class="property-value">{{equipment.pbx.company_id}}</span>
            </span>
            <span class="property-obj">
              <b translate>equipment.details.table.pbx-id</b>
              <span class="property-value">{{equipment.pbx.id}}</span>
            </span>
          </td>
          <td style="width: 240px; text-align: right;">
            <button class="vox-btn btn btn-danger" [disabled]="company && company.readOnly"
              (click)="deallocateFromPbx()">
              <i class="icon-small-delete"></i>
              <span translate>equipment.details.buttons.deallocate-pbx</span>
            </button>
          </td>
        </ng-container>
        <ng-container *ngIf="!equipment.pbx">
          <td>false</td>
          <td style="width: 240px; text-align: right;">
            <button class="vox-btn btn btn-success" [disabled]="company && company.readOnly"
              (click)="openAllocateToPbxPopup()">
              <i class="icon-small-info"></i>
              <span translate>equipment.details.buttons.allocate-pbx</span>
            </button>
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="loading.loadingSendInstructions">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '40px', 'margin-bottom': 0, 'margin-top': '5px'}">
          </ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loading.loadingSendInstructions">
        <td translate>equipment.details.nav-tabs.overview.table.send-instructions.label</td>
        <td></td>
        <td class="text-right">
          <div class="tooltip-container" placement="top" [ngbTooltip]="getSendInstructionsTooltip() | translate">
            <button (click)="sendInstructions(equipment.mac_address)" class="btn btn-success vox-btn" type="button" [disabled]="company && company.readOnly || (equipment.status === 'AVAILABLE')"><i class="icon-small-sent"></i><span translate>equipment.details.nav-tabs.overview.table.send-instructions.button.label</span></button>
          </div>
        </td>
      </tr>
      <tr *ngIf="loading.loadingAssign">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '40px', 'margin-bottom': 0, 'margin-top': '5px'}">
          </ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loading.loadingAssign && equipment.pbx && equipment.model !== 'AIR'">
        <td translate>equipment.details.nav-tabs.overview.table.assigned-user</td>
        <ng-container *ngIf="equipment.user">
          <td class="properties-list">
            <span class="property-obj"><b translate>equipment.details.table.first-name</b> <span
                class="property-value">{{equipment.user.first_name}}</span></span>
            <span class="property-obj"><b translate>equipment.details.table.last-name</b> <span
                class="property-value">{{equipment.user.last_name}}</span></span>
            <span class="property-obj"><b translate>equipment.details.table.email</b> <span
                class="property-value">{{equipment.user.email}}</span></span>
            <span class="property-obj"><b translate>equipment.details.table.extension</b> <span
                class="property-value">{{equipment.user.extension.number}}</span></span>
          </td>
          <td style="width: 240px; text-align: right;">
            <button class="vox-btn btn btn-danger" [disabled]="company && company.readOnly"
              (click)="unassignFromUser()">
              <i class="icon-small-delete"></i>
              <span translate>equipment.details.buttons.unassign-user</span>
            </button>
          </td>
        </ng-container>
        <ng-container *ngIf="!equipment.user">
          <td>false</td>
          <td style="width: 240px; text-align: right;">
            <button class="vox-btn btn btn-success" [disabled]="company && company.readOnly"
              (click)="openAssignUserPopup()">
              <i class="icon-big-user"></i>
              <span translate>equipment.details.buttons.assign-user</span>
            </button>
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="loading.loadingOutboundDid && equipment.model!=='AIR'">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '40px', 'margin-bottom': 0, 'margin-top': '5px'}">
          </ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loading.loadingOutboundDid && equipment.model!=='AIR'">
        <td translate>equipment.details.nav-tabs.overview.table.outbound-did.description</td>
        <td *ngIf="equipment.user">{{equipment.outbound_did || '-'}}</td>
        <td *ngIf="!equipment.user" translate>equipment.details.nav-tabs.overview.table.outbound-did.no-user</td>
        <td>
          <button class="vox-btn btn btn-success"
            [disabled]="company && company.readOnly || !equipment.pbx || !equipment.user || equipment.model === 'AIR'"
            (click)="updateOutboundDid()">
            {{'equipment.details.buttons.update-did' | translate}}
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>